define([
	"dojo/_base/declare",
	"csi/types",
	"csi/utility/numberUtility",
	"./NumberTextBox",
], function (declare, types, numberUtility, NumberTextBox) {

	return declare(NumberTextBox, {
		parse: function (/*String*/ value, /*number.__FormatOptions*/ constraints) {

			//Format doesn't matter when returning a Number, so parse using non-percent functionality
			constraints = constraints.pattern.replace("%", "");
			value = value.replace("%", "");
			const val = this.inherited(arguments);

			return val / 100.0;
		},

		format: function (value, constraints) {
			var val = numberUtility.formatNumber(value, constraints.pattern);

			return val;
		},

		inputAndParseAttr: function(value) {
			this._setValueAttr(this.parse(value, this.constraints));
		},

		_setValueAttr: function (/*Number*/ value, /*Boolean?*/ priorityChange, /*String?*/ formattedValue) {

			//Casting to Number ensures the initial conversion to percent works properly
			value = Number(value);
			this.inherited(arguments, [value, priorityChange, formattedValue]);
		},

		//filter is called before the value is multiplied by 100 for percentages. Changes need to be made to preserve precision
		filter: function (/*Number*/ value) {

			//Need to check for string type to prevent returning NaN when value is 0
			if (value == null || value === '') {
				return NaN;
			} else if (typeof value == "number" && !isNaN(value) && value != 0) {
				value = numberUtility.numberRound(value, this._decimalInfo.places + 2);
			}

			return value;
		}
	});
});
